var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-8" },
      [
        _c("input-group", { attrs: { icon: "far fa-hourglass" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.time,
                expression: "time"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "number", disabled: !_vm.unit },
            domProps: { value: _vm.time },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.time = $event.target.value
              }
            }
          })
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c(
          "input-group",
          { attrs: { icon: "far fa-clock" } },
          [
            _vm.options.length != 0
              ? _c(
                  "v-select",
                  {
                    staticClass: "form-control",
                    attrs: {
                      options: _vm.options,
                      clearable: false,
                      "close-on-select": ""
                    },
                    model: {
                      value: _vm.unit,
                      callback: function($$v) {
                        _vm.unit = $$v
                      },
                      expression: "unit"
                    }
                  },
                  [
                    _c("div", {
                      attrs: { slot: "no-options" },
                      slot: "no-options"
                    })
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }